module.exports = __webpack_public_path__ + "img/anchor-p2.200835e5.jpg";